import React from "react";
import {
  Spin,
  Upload,
  message,
  Button,
  Form,
  Alert,
  Image,
  Progress,
  Input,
  Collapse,
  Descriptions,
  Flex,
  Checkbox,
  Popover,
} from "antd";
import {
  CheckOutlined,
  CloudUploadOutlined,
  DeleteOutlined,
  InfoCircleOutlined,
  ReloadOutlined,
  SafetyCertificateOutlined,
  
} from "@ant-design/icons";

import Apiauth from "../../api/Apiauth";
import { DOCTYPerrorMessage, getFileSizeInfo, openNotification, showToast } from "../../utils";
import { CopyTextToClipboard } from "../../helpers/copy";
import { itemsDescriptions } from "./itemsDescriptions";
import ImgCrop from "antd-img-crop";
import expImg from "../../assets/images/Screenshot_1.png";
import Swal from "sweetalert2";

const statusFalse = ["NOT_MATCH", "DUPLICATED"];
const MAX_SIZE_MB = 1;

class VerifySlip extends React.Component {
  formRef = React.createRef();
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      input: true,
      apiResponse: null,
      apiError: null,
      fileList: [],
      previewImage: null,
      uploadProgress: 0, // สำหรับ Progress Bar ด้านล่าง (API Call จริง)
      showDragger: false,
      onHiden: false,
      txtBtn: "ตรวจสอบ",
      isConfirm: false,
      customer_uuid: this.props.uuid || null,
      showCropNote: false,
      showCropAfterError: false,
      onProgress: false, // ใช้ควบคุมการแสดง Progress Bar ด้านล่าง
      showBtnCheck: true,
      uploading: 0, // สำหรับ Progress Bar วงกลมใน itemRender (Custom Request จำลอง)
      sizeImage: 0,
    };
    this.inputRef = React.createRef();
    this.handleFocusAll = this.handleFocusAll.bind(this);
    this.handleFileChange = this.handleFileChange.bind(this);
    this.onRemove = this.onRemove.bind(this);
  }

  handleFocusAll() {
    const { uuid } = this.props;
    if (uuid) {
      CopyTextToClipboard(uuid);
    }
    this.inputRef.current.focus({
      cursor: "all",
    });
  }
  handleFileChange = (info) => {
    let newFileList = [...info.fileList];

    newFileList = newFileList.slice(-1);

    const { originFileObj, status, percent } = info.file;
    if (originFileObj) {
      const reader = new FileReader();
      reader.readAsDataURL(originFileObj);
      reader.onload = () => {
        this.setState({ previewImage: reader.result });
      };
      reader.onerror = (error) => {
        console.error("Error reading file:", error);
        openNotification(
          "error",
          "File Read Error",
          "ไม่สามารถอ่านไฟล์รูปภาพได้"
        );
        this.setState({
          previewImage: null,
          fileList: [],
          uploadProgress: 0,
          uploading: 0,
        });
      };
    } else {
      this.setState({ previewImage: null, uploadProgress: 0, uploading: 0 });
    }

    this.setState({ fileList: newFileList }, () => {
      if (newFileList.length === 0) {
        this.setState({
          apiResponse: null,
          apiError: null,
          uploadProgress: 0,
          onHiden: false,
          isConfirm: false,
          txtBtn: "ตรวจสอบ",
          showCropNote: false,
          uploading: 0,
          onProgress: false,
        });
      }
    });

    if (status === "uploading") {
      this.setState({
        uploading: percent || 0,
        onProgress: false,
      });
    } else if (status === "done") {
      this.setState({
        uploading: 100,
        onProgress: true,
      });
      console.log(`${info.file.name} file uploaded successfully.`);
    } else if (status === "error") {
      this.setState({ uploading: 0, onProgress: false });
      message.error(`${info.file.name} file upload failed.`);
    }
  };

  customUploadRequest = ({ file, onSuccess, onError, onProgress }) => {
    const totalTime = 1500;
    const intervals = 3;
    let currentStep = 0;

    const intervalId = setInterval(() => {
      currentStep++;
      const percent = Math.round((currentStep / intervals) * 100);

      onProgress({ percent, loaded: currentStep, total: intervals }, file);

      if (currentStep >= intervals) {
        clearInterval(intervalId);
        onSuccess("ok");
      }
    }, totalTime / intervals);
  };
  beforeUpload = (file) => {
    const isJpgOrPng = file.type === "image/jpeg" || file.type === "image/png";
    if (!isJpgOrPng) {
      Swal.fire({
        title: "เกิดข้อผิดพลาด!",
        text: "คุณสามารถอัปโหลดไฟล์ JPG/PNG เท่านั้น!",
        icon: "warning",
      });
      return Upload.LIST_IGNORE;
    }
    const fileSizeInMB = file.size / 1024 / 1024;

    const isLt1M = fileSizeInMB < MAX_SIZE_MB;
    let errorMessage = `เกิดข้อผิดพลาด รูปภาพใหญ่เกินกว่าที่ระบบกำหนด`;
    this.setState({ sizeImage: 0 });
    if (!isLt1M) {
      Swal.fire({
        title: `รูปภาพต้องน้อยกว่า ${MAX_SIZE_MB}MB!`,
        text: `แนะนำให้ แคปเอาเฉพาะส่วนของ QRcode`,
        icon: "warning",
      });
      this.setState({
        showCropNote: true,
        showCropAfterError: true,
        loading: false,
        fileList: [],
        uploadProgress: 0,
        apiError: errorMessage,
        error: { status: 413, message: errorMessage },
      });
      return Upload.LIST_IGNORE;
    }
    let size = getFileSizeInfo(file);
    this.setState({ sizeImage: size?.kilobytes || 0,  error: null });
    return true;
  };

  onRemove = (file) => {
    this.setState({
      fileList: [],
      previewImage: null,
      apiResponse: null,
      apiError: null,
      error: null,
      onHiden: false,
      txtBtn: "ตรวจสอบ",
      uploadProgress: 0,
      isConfirm: false,
      showCropNote: false,
      onProgress: false,
      uploading: 0,
      showBtnCheck: true,
      sizeImage: 0,
    });
    this.formRef.current.setFieldsValue({ file: [] });
    return true;
  };

  onFinish = async () => {
    this.props.handleChangeLoading(true);
    const { fileList } = this.state;
    const { uuid } = this.props;
    this.setState({
      loading: true,
      txtBtn: "loading...",
      uploadProgress: 0,
      onHiden: false,
      showCropNote: false,
      error: null,
    });
    try {
      const formData = new FormData();
      if (!uuid) {
        openNotification(
          "error",
          "เกิดข้อผิดพลาด",
          "ไม่พบข้อมูล Customer UUID."
        );
        this.setState({ loading: false, uploadProgress: 0 });
        this.props.handleChangeLoading(false);
        return;
      }
      if (fileList.length > 0 && fileList[0].originFileObj) {
        formData.append("file", fileList[0].originFileObj);
        formData.append("type", "SLIP_VERRIFY");
        formData.append("customerUuid", uuid);
      } else {
        openNotification("error", "เกิดข้อผิดพลาด", "กรุณาอัปโหลดรูปสลิป.");
        this.setState({ loading: false, uploadProgress: 0 });
        this.props.handleChangeLoading(false);
        return;
      }
      const response = await Apiauth.getUploadSlip(formData, {
        onUploadProgress: (progressEvent) => {
          const percentCompleted = Math.round(
            (progressEvent.loaded * 100) / progressEvent.total
          );
          this.setState({ uploadProgress: percentCompleted });
        },
      });
      const data = response.data;
      if (response.status !== 200) {
        openNotification(
          "error",
          "ตรวจสอบไม่สำเร็จ",
          data.message || "ไม่สามารถทำรายการได้"
        );
        this.setState({
          loading: false,
          txtBtn: "ลองอีกครั้ง",
          uploadProgress: 0,
        });
        this.props.handleChangeLoading(false);
        return;
      }
      if (statusFalse.includes(data?.status)) {
        openNotification("warning", data?.status, data?.note);
        this.props.handleShowBtnConfirm(false, data);

        this.setState({
          loading: false,
          apiResponse: response,
          onHiden: true,
          txtBtn: "ลองอีกครั้ง",
          uploadProgress: 0,
        });
        this.props.handleChangeLoading(false);
        return;
      } 
      // Success

      this.setState({
        apiResponse: response,
        loading: false,
        onHiden: true,
        showCropNote: false,
        showCropAfterError: false,
        isConfirm: true,
        showBtnCheck: false,
        txtBtn: "ตรวจสอบ",
        uploadProgress: 100,
      });
      this.props.handleChangeLoading(false);
      this.props.handleShowBtnConfirm(true, data);
      showToast("success", "SLIP MATCHED");
    } catch (error) {
      console.error("Error checking slip:", error);

      let errorMessage = "เกิดข้อผิดพลาดในการตรวจสอบรายการ";
      const status = error.response ? error.response.status : error.status;
      const ERROR_STATUSES = [500, 413];
      if (ERROR_STATUSES.includes(status)) {
        errorMessage = error.message;
        this.setState({
          showCropNote: true,
          showCropAfterError: true,
          loading: false,
          fileList: [],
          uploadProgress: 0,
          error: { status: status, message: errorMessage },
        });
      } else if (error.response) {
        console.error("Error", error);
        if (error.response.data && error.response.data.message) {
          errorMessage = error.response.data.message;
        } else if (error.response.data) {
          errorMessage = DOCTYPerrorMessage(error.response.data);
        } else {
          errorMessage = `Server error: ${error.response.status}`;
        }
        this.setState({ error: error, loading: false, uploadProgress: 0 });
        openNotification("error", "ตรวจสอบไม่สำเร็จ", errorMessage);
      } else if (error.request) {
        console.error("Error request:", error.request);
        errorMessage = "ไม่ได้รับการตอบกลับจากเซิร์ฟเวอร์ กรุณาลองอีกครั้ง.";
        this.setState({ error: error, loading: false, uploadProgress: 0 });
        openNotification("error", "ตรวจสอบไม่สำเร็จ", errorMessage);
      } else {
        console.error("Error message:", error.message);
        errorMessage = error.message;
        this.setState({ error: error, loading: false, uploadProgress: 0 });
        openNotification("error", "ตรวจสอบไม่สำเร็จ", errorMessage);
      }
      this.setState({
        apiError: errorMessage,
        loading: false,
        uploadProgress: 0,
      });
      this.props.handleChangeLoading(false);
    }
  };

  onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
    openNotification("error", "ข้อมูลไม่ถูกต้อง", "กรุณาอัปโหลดรูปสลิป");
  };

  targetPreview = () => {
    let show = this.state.onHiden;
    this.setState({ onHiden: !show });
  };

  render() {
    const {
      loading,
      apiResponse,
      apiError,
      fileList,
      previewImage,
      uploadProgress,
      error,
      onHiden,
      isConfirm,
      showCropNote,
      uploading,
      showCropAfterError,
      showBtnCheck,
      sizeImage
    } = this.state;

    const { t, uuid, resAllDataMerchang } = this.props;

    const sharedProps = {
      style: { width: "100%" },
      defaultValue: uuid,
      ref: this.inputRef,
    };
    let res = apiResponse?.data;

    let status = res?.status;
    let note = res?.note;

    const descriptionsData = itemsDescriptions({
      resAllDataMerchang: resAllDataMerchang,
      apiResponse: apiResponse,
      previewImage: previewImage,
    });
    let columnProps = {
      xxl: 1,
      xl: 1,
      lg: 1,
      md: 1,
      sm: 1,
      xs: 1,
    };
    const genExtra = () => (
      <Flex gap="middle" justify="end" horizontal>
        {isConfirm && (
          <Button
            style={{ fontSize: 13 }}
            type="primary"
            size="small"
            onClick={() => this.props.handleConfirmTransaction(res)}
          >
            <CheckOutlined /> {"Approval"}
          </Button>
        )}
        <Button
          size="small"
          style={{ fontSize: 13 }}
          onClick={() => {
            this.setState({
              fileList: [],
              previewImage: null,
              apiResponse: null,
              apiError: null,
              uploadProgress: 0,
              onHiden: null,
              error: null,
              txtBtn: "ตรวจสอบ",
              isConfirm: false,
              uploading: 0,
              onProgress: false,
            });
            this.formRef.current.resetFields();
          }}
          icon={<ReloadOutlined />}
        >
          {"Reset"}
        </Button>
             
      </Flex>
    );
    const itemsCollapse = [
      {
        key: "1",
        label: "รายละเอียด...",
        children: (
          <div className="p-1">
            <Descriptions
              bordered
              span={12}
              size="small"
              column={columnProps}
              items={descriptionsData}
            />
          </div>
        ),
        extra: genExtra(),
      },
    ]; //

    const uploadProps = {
      listType: "picture",
      maxCount: 1,
      fileList: fileList,
      customRequest: this.customUploadRequest,
      onChange: this.handleFileChange,
      beforeUpload: this.beforeUpload,
      onRemove: this.onRemove,
      disabled: !this.props.uuid || loading,
      itemRender: (originNode, file) => {
        if (!file) return null;

        let length = fileList.length;
        let statusDone = file?.status === "done";
        let isCustomRequestUploading = file.status === "uploading";
        let isFileReady = statusDone || file.status === "error";
        let disabled = loading || length < 0 || isConfirm || !statusDone;
        let dNone =
          !isFileReady || isCustomRequestUploading || !showBtnCheck
            ? "d-none"
            : "";
        let ProgressHtml = (
          <Progress type="circle" size={50} percent={uploading} />
        );
        return (
          <>
            <Flex
              justify="space-between"
              align="center"
              style={{
                padding: "8px",
                border: `1px solid ${statusDone ? "#3eacff " : "#ff4d4f"}`,
                margin: 5,
                borderRadius: 8,
              }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                }}
              >
                {isCustomRequestUploading ? (
                  ProgressHtml
                ) : (
                  <>
                    <Checkbox checked={statusDone} />
                    <Image
                      src={previewImage}
                      alt="Preview"
                      className={`img-fluid img-thumbnail`}
                      style={{
                        width: 50,
                        border: "1px solid #ddd",
                      }}
                      preview={true}
                    />
                  </>
                )}
                <span
                  style={{
                    maxWidth: "200px",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    marginRight: 5,
                  }}
                >
                  {sizeImage}KB
                </span>
              </div>
              <Flex gap="small">
                <Button
                  type="primary"
                  size="small"
                  className={`${dNone}`}
                  icon={<SafetyCertificateOutlined />}
                  disabled={disabled}
                  onClick={() => this.formRef.current.submit()}
                >
                  ตรวจสอบ
                </Button>
                <Button
                  danger
                  size="small"
                  icon={<DeleteOutlined />}
                  onClick={() => this.onRemove(file)}
                  disabled={loading}
                >
                  ลบ
                </Button>
              </Flex>
            </Flex>
          </>
        );
      },
    };
    const imgCropProps = {
      showReset: true,
      rotationSlider: true,
      shape: "round",
      modalTitle: (
        <>
          <span className="mb-3" style={{ color: "InfoText" }}>
            กรุณา Crop เฉพาะ **QR Code** ของสลิปให้เห็นชัดเจน{" "}
            <Popover
              content={
                <Image
                  src={expImg}
                  alt="Preview"
                  className={`img-fluid img-thumbnail`}
                  style={{
                    width: 150,
                    border: "1px solid #ddd",
                  }}
                  preview={true}
                />
              }
            >
              <InfoCircleOutlined
                style={{ cursor: "pointer", color: "InfoText" }}
              />
            </Popover>
          </span>
          <ul style={{ fontSize: 14 }}>
            <li>คลิกซ้ายค้างเพื่อลากไปยังตำแหน่งที่ต้องการ</li>
            <li>เลื่อน ขึ้น/ลง = Zoom-in / Zoom-out</li>
          </ul>
        </>
      ),
      modalProps: {
        closable: false,
        maskClosable: false,
        width: 600,
      },
    };

    return (
      <>
        <div className="p-1">
          {apiResponse && (
            <>
              <Alert
                message={t(status)}
                description={note}
                type={statusFalse.includes(status) ? "warning" : "success"}
                showIcon
                className="mt-3 mb-3"
              />
              <Collapse
                ghost
                items={itemsCollapse}
                defaultActiveKey={["1"]}
                expandIconPosition="start"
              />
            </>
          )}
          {error && (
            <Alert
              message={`statusCode: ${error?.status}`}
              description={apiError}
              type="error"
              showIcon
              closable
              onClose={() => this.setState({ error: null })}
              className="mt-3 mb-3"
            />
          )}
          <Spin spinning={loading} tip={t("Verifying...")}>
            <Form
              layout="vertical"
              ref={this.formRef}
              variant={"outlined"}
              initialValues={{ variant: "outlined", customer_uuid: uuid }}
              onFinish={this.onFinish}
              className="mt-2"
              onFinishFailed={this.onFinishFailed}
            >
              <Form.Item
                name="customer_uuid"
                label="Customer UUID"
                rules={[
                  {
                    required: !uuid,
                    message: t("Please required a Customer UUID!"),
                  },
                ]}
              >
                <Input
                  readOnly
                  onClick={this.handleFocusAll}
                  {...sharedProps}
                  defaultValue={uuid || ""}
                  value={uuid}
                  placeholder="กรอก Customer UUID"
                />
              </Form.Item>
              <Form.Item
                name="file"
                valuePropName="fileList"
                label="Upload a slip image"
                getValueFromEvent={(e) => {
                  if (Array.isArray(e)) {
                    return e;
                  }
                  return e && e.fileList;
                }}
                rules={[
                  {
                    required: fileList.length === 0,
                    message: t("Please upload a slip image!"),
                  },
                ]}
              >
                {!showCropAfterError ? (
                  <Upload {...uploadProps}>
                    <Button
                      icon={<CloudUploadOutlined />}
                      disabled={!uuid || fileList.length > 0}
                      style={{ width: "100%" }}
                      className="mb-3"
                    >
                      {fileList.length > 0
                        ? t("File Selected")
                        : t("Click here to upload your slip.")}
                    </Button>
                  </Upload>
                ) : (
                  <ImgCrop {...imgCropProps}>
                    <Upload {...uploadProps}>
                      <Button
                        icon={<i className='bx bx-crop' ></i>}
                        disabled={!uuid || fileList.length > 0}
                        style={{ width: "100%" }}
                        type="primary"
                        className="mb-3"
                      >
                        {fileList.length > 0
                          ? t("File image selected.")
                          : t("Crop image before uploading.")}
                      </Button>
                    </Upload>{" "}
                     
                  </ImgCrop>
                )}
              </Form.Item>
            </Form>
          </Spin>

          {showCropNote && (
            <Alert
              message="คำแนะนำ"
              description={`ในกรณีที่การตรวจสอบไม่สำเร็จ หรือ รูปภาพสลิปมีขนาดใหญ่กว่า ${MAX_SIZE_MB}MB โปรดลองใหม่อีกครั้ง โดยจะมีฟังก์ชัน Crop เพื่อตัดเฉพาะส่วน **QR Code** ของสลิปเท่านั้น`}
              type="info"
              showIcon
              className="mt-3 mb-3"
            />
          )}
          {uploadProgress > 0 && uploadProgress < 100 && !onHiden && (
            <>
              <div style={{ padding: "0 0 20px 0" }}>
                <Progress percent={uploadProgress} />
              </div>
            </>
          )}
        </div>
      </>
    );
  }
}

export default VerifySlip;
